<script>
export let color

let classes = "self-start text-white text-xs p-2 rounded-full "
$: classes = color === 'primary' ? classes += 'bg-primary-800' : classes += 'bg-gray-800'
</script>

<div class={classes}>
    <slot></slot>
</div>